import RadiusCard from "@components/layout/RadiusCard";
import { colors } from "@styles/colors";
import { Button, Text, YStack } from "tamagui";

export const IoTDevice = () => {
  return (
    <RadiusCard>
      <YStack py="$3">
        <Text textAlign="center" fontWeight="bold">
          尚未連接任何裝置
        </Text>
        <Button className="shadow-lg primary-bg-gradient" color={colors.light} alignSelf="center" mt="$4">
          新增裝置
        </Button>
      </YStack>
    </RadiusCard>
  );
};

export default IoTDevice;
